import {useAppSelector} from './reduxHooks';
import {useGetStoreDetailsQuery} from '../api/storesApi';
import {selectPrimaryCampaign} from '../slices/storesSlice';
import {useStoreSlug} from './useStoreSlug';

interface UseCampaignStatus {
  isCampaignCompleted: boolean | null;
  isCampaignGoalMet: boolean | null;
  isCampaignCanceled: boolean | null;
  isCampaignActive: boolean | null;
}

export const useCampaignStatus = (): UseCampaignStatus => {
  const urlSlug = useStoreSlug();
  useGetStoreDetailsQuery(urlSlug);
  const campaign = useAppSelector(selectPrimaryCampaign);

  if (!campaign)
    return {
      isCampaignCompleted: null,
      isCampaignGoalMet: null,
      isCampaignCanceled: null,
      isCampaignActive: null
    };

  const status = campaign?.status || '';

  const totalQuantity = campaign?.totalItemsQuantity;
  const expectedQuantity = campaign?.expectedQuantity;

  const isCampaignCompleted = status === 'completed';

  const isCampaignGoalMet = totalQuantity && totalQuantity >= expectedQuantity;

  const isCampaignCanceled = status === 'canceled';

  const isCampaignActive = status === 'active';

  return {
    isCampaignCompleted,
    isCampaignGoalMet,
    isCampaignCanceled,
    isCampaignActive
  };
};
export default useCampaignStatus;
